import type { SuggestionOptions } from "@tiptap/suggestion";
import type { SuggestionPluginState } from "../suggestions/suggestionRenderer";
import { PluginKey } from "@tiptap/pm/state";
import Suggestion from "@tiptap/suggestion";
import { Extension } from "@tiptap/vue-3";
import { createSuggestionRenderer } from "../suggestions";
import CommandsList from "./CommandsList.vue";

export interface CommandsOptions {
  suggestion: Omit<SuggestionOptions, "editor">;
  disableFor: string[];
}

export const SlashCommandsPluginKey = new PluginKey<SuggestionPluginState>("slash-commands");

export default Extension.create<CommandsOptions>({
  name: "slash-commands",

  // increase priority, so that keydown events will be processed in here first before Paragraph node
  priority: 10000,

  addOptions() {
    return {
      disableFor: [],
      suggestion: {
        char: "/",
        pluginKey: SlashCommandsPluginKey,
      },
    };
  },

  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        ...this.options.suggestion,
        allow: ({ state }) => {
          const node = state.selection.$anchor.parent;
          const shouldDisable = this.options.disableFor.includes(node.type.name);
          if (shouldDisable) return false;
          return true;
        },
      }),
    ];
  },
}).configure({
  suggestion: createSuggestionRenderer(CommandsList),
});
